import {
    FETCH_USER_BEGIN,
    FETCH_USER_SUCCESS,
    FETCH_USER_FAILURE
} from '../constants/User';

const initialState = {
    Users: [],
    isLoading: false,
    error: ""
}


export const getUsersReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_USER_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_USER_FAILURE:
            return {
                ...initialState,
                isLoading: false,
                Users: null
            };
        case FETCH_USER_SUCCESS:
            return {
                ...initialState,
                Users: payload.Users,
                isLoading: true,
            };
        default:
            return state;
    }
}


